import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import App from './App';
import 'tailwindcss/tailwind.css';
import './styles/main.scss';
import { UserProvider } from './contexts/UserContext';
import { CartProvider } from './contexts/CartContext';
import { SettingsProvider } from './contexts/SettingsContext.tsx';
import { AuthProvider } from './contexts/AuthContext.tsx';
import { FronteggProvider } from '@frontegg/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DNS,
  integrations: [],
});

const contextOptions = {
  baseUrl: import.meta.env.VITE_FRONTEGG_BASE_URL,
  clientId: import.meta.env.VITE_FRONTEGG_CLIENT_ID, 
};

const authOptions = {
  keepSessionAlive: true // Uncomment this in order to maintain the session alive
};

const root = document.getElementById('root');

if (root) {
  const rootElement = createRoot(root);

  rootElement.render(
    <Sentry.ErrorBoundary
      fallback={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100vw',
            height: '100vh'
          }}
        >
          <p>An error has occurred, please reload the page</p>
        </div>
      }
    >
      <UserProvider>
        <CartProvider>
          <SettingsProvider>
            <Router>
              <FronteggProvider contextOptions={contextOptions} hostedLoginBox={true} authOptions={authOptions}>
                <AuthProvider>
                  <Routes>
                    <Route path="*" element={<App />} />
                  </Routes>
                </AuthProvider>
              </FronteggProvider>
            </Router>
          </SettingsProvider>
        </CartProvider>
      </UserProvider>
    </Sentry.ErrorBoundary>,
  );
}
